module.exports = __webpack_public_path__ + "static/visual_3-96355c242a45c2f21ab591b90e21f1fa.jpg";